<script setup lang="ts">
defineProps<{ eyebrow: string; title: string; description: string; revision: string }>();
</script>
<template>
  <header class="entity-header">
    <p class="eyebrow">{{ eyebrow }}</p>
    <h1>{{ title }}</h1>
    <p class="lede">{{ description }}</p>
    <div class="revision">
      <span>Immutable revision</span><code :title="revision">{{ revision.slice(0, 22) }}…</code>
    </div>
  </header>
</template>
